module.exports = __webpack_public_path__ + "static/media/journey.2c435be1.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/journey.png
// module id = 615
// module chunks = 0